// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { GlobalEffects } from './store/effects';
import * as fromGlobal from './store/reducer';

// SERVICES
import { GlobalStoreService } from './global-store.service';
import { GlobalService } from './services/global.service';

/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['user'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure global ngrx related stuff.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) configure global store ng module
 */
@NgModule({
  imports: [
    StoreModule.forFeature('global', fromGlobal.reducer, { metaReducers }),
    EffectsModule.forFeature([GlobalEffects]),
  ],
  declarations: [],
  providers: [
    GlobalService,
    GlobalStoreService,
  ],
})
export class GlobalStoreModule { }
